import { useFormik } from "formik";
import React from "react";
import {
  Col,
  DropdownItem,
  FormGroup,
  Form,
  Label,
  Input,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
} from "reactstrap";
import SimpleBar from "simplebar-react";
import * as Yup from "yup";
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import { format } from "date-fns";

export default function Filter() {
  const validation = useFormik({
    initialValues: {
      ano: "",
      mes: "",
      dia: "",
      realizador: "",
      setor: "",
      tipo_servico: "",
      status: "",
      finalizado: "",
      solicitado: "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Por favor, insira o nome completo"),
    }),
    onSubmit: values => {
      //console.log(values);
    },
  });

  return (
    <div
      style={{
        position: "fixed",
        top: "100px",
        right: "10px",
        zIndex: 1000,
      }}
    >
      <Card>
        <CardBody style={{ padding: "0px" }}>
          <SimpleBar
            style={{ height: "70vh", width: "300px", paddingTop: "5px" }}
          >
            <div
              style={{
                paddingLeft: "10px",
                paddingRight: "10px",
              }}
            >
              <Form>
                <Col>
                  <FormGroup>
                    <Label htmlFor="validationCustom03" className="small">
                      Moeda
                    </Label>
                    <Input
                      name="mes"
                      placeholder="Superior"
                      type="select"
                      className="form-control"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.mes || ""}
                      invalid={
                        validation.touched.mes && validation.errors.mes
                          ? true
                          : false
                      }
                    >
                      <option value="MZN">MZN</option>
                      <option value="USD">USD</option>
                      <option value="EUR">EUR</option>
                      <option value="ZAR">ZAR</option>
                    </Input>
                  </FormGroup>
                </Col>

                <Col>
                  <FormGroup>
                    <Label htmlFor="ano " className="small">
                      Ano
                    </Label>
                    <Input
                      name="ano"
                      placeholder="Superior"
                      type="select"
                      className="form-control form-control-sm"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.ano || ""}
                    >
                      <option value="">Selecione</option>
                      {Array.from({ length: 10 }, (_, index) => (
                        <option key={index} value={index + 2015}>
                          {index + 2015}
                        </option>
                      ))}
                    </Input>
                  </FormGroup>
                </Col>

                <Col>
                  <FormGroup>
                    <Label htmlFor="validationCustom03" className="small">
                      Mês
                    </Label>
                    <Input
                      name="mes"
                      placeholder="Superior"
                      type="select"
                      className="form-control"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.mes || ""}
                      invalid={
                        validation.touched.mes && validation.errors.mes
                          ? true
                          : false
                      }
                    >
                      <option value="">Selecione</option>
                      {[
                        "Janeiro",
                        "Fevereiro",
                        "Março",
                        "Abril",
                        "Maio",
                        "Junho",
                        "Julho",
                        "Agosto",
                        "Setembro",
                        "Outubro",
                        "Novembro",
                        "Dezembro",
                      ].map((month, index) => (
                        <option key={index} value={index + 1}>
                          {month}
                        </option>
                      ))}
                    </Input>
                  </FormGroup>
                </Col>
                <Col>
                  <FormGroup>
                    <Label htmlFor="validationCustom03" className="small">
                      Dia
                    </Label>
                    <Input
                      name="dia"
                      placeholder="Superior"
                      type="select"
                      className="form-control"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.dia || ""}
                      invalid={
                        validation.touched.dia && validation.errors.dia
                          ? true
                          : false
                      }
                    >
                      <option value="">Selecione</option>
                      {Array.from({ length: 31 }, (_, index) => (
                        <option key={index} value={index + 1}>
                          {index + 1}
                        </option>
                      ))}
                    </Input>
                  </FormGroup>
                </Col>
                <Col>
                  <FormGroup>
                    <Label htmlFor="validationCustom03" className="small">
                      Finalizado Entre
                    </Label>
                    <Flatpickr
                      options={{
                        mode: "range",
                        altInput: true,
                        altFormat: "F j, Y",
                        dateFormat: "Y-m-d",
                        closeOnSelect: false,
                      }}
                      value={validation.values.realizador}
                      onChange={(date: Date[]) => {
                        const formattedDate = date.length
                          ? format(date[0], "yyyy-MM-dd")
                          : "";
                        validation.setFieldValue("ano", formattedDate);
                      }}
                      onClick={(e: any) => e.stopPropagation()}
                      onBlur={validation.handleBlur}
                      className={`form-control ${validation.touched.realizador &&
                        validation.errors.realizador
                        ? "invalid-field"
                        : ""
                        }`}
                    />
                  </FormGroup>
                </Col>
                <Col>
                  <FormGroup>
                    <Label htmlFor="validationCustom03" className="small">
                      Solicitados Entre
                    </Label>
                    <Flatpickr
                      options={{
                        mode: "range",
                        altInput: true,
                        altFormat: "F j, Y",
                        dateFormat: "Y-m-d",
                      }}
                      value={validation.values.solicitado}
                      onChange={(date: Date[]) => {
                        const formattedDate = date.length
                          ? format(date[0], "yyyy-MM-dd")
                          : "";
                        validation.setFieldValue("solicitado", formattedDate);
                      }}
                      onBlur={validation.handleBlur}
                      className={`form-control ${validation.touched.solicitado &&
                        validation.errors.solicitado
                        ? "invalid-field"
                        : ""
                        }`}
                    />
                  </FormGroup>
                </Col>
                <Col>
                  <FormGroup>
                    <Label htmlFor="validationCustom03" className="small">
                      Realizado por
                    </Label>
                    <Input
                      name="realizador"
                      placeholder="Superior"
                      type="select"
                      className="form-control"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.realizador || ""}
                      invalid={
                        validation.touched.realizador &&
                          validation.errors.realizador
                          ? true
                          : false
                      }
                    >
                      <option value="">Selecione</option>
                    </Input>
                  </FormGroup>
                </Col>
                <Col>
                  <FormGroup>
                    <Label htmlFor="validationCustom03" className="small">
                      Setor
                    </Label>
                    <Input
                      name="setor"
                      placeholder="Superior"
                      type="select"
                      className="form-control"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.setor || ""}
                      invalid={
                        validation.touched.setor && validation.errors.setor
                          ? true
                          : false
                      }
                    >
                      <option value="">Selecione</option>
                    </Input>
                  </FormGroup>
                </Col>
                <Col>
                  <FormGroup>
                    <Label htmlFor="validationCustom03" className="small">
                      Tipo Serviço
                    </Label>
                    <Input
                      name="tipo_servico"
                      placeholder="Superior"
                      type="select"
                      className="form-control"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.tipo_servico || ""}
                      invalid={
                        validation.touched.tipo_servico &&
                          validation.errors.tipo_servico
                          ? true
                          : false
                      }
                    >
                      <option value="">Selecione</option>
                    </Input>
                  </FormGroup>
                </Col>
                <Col>
                  <FormGroup>
                    <Label htmlFor="validationCustom03" className="small">
                      Status
                    </Label>
                    <Input
                      name="status"
                      placeholder="Superior"
                      type="select"
                      className="form-control"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.status || ""}
                      invalid={
                        validation.touched.status && validation.errors.status
                          ? true
                          : false
                      }
                    >
                      <option value="">Selecione</option>
                    </Input>
                  </FormGroup>
                </Col>
              </Form>
            </div>
          </SimpleBar>
        </CardBody>
      </Card>
    </div>
  );
}
